import React from "react";

interface ModalAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribe: () => void;
  title: string;
  submitText?: string;
}

const ModalAlert: React.FC<ModalAlertProps> = ({
  isOpen,
  onClose,
  onSubscribe,
  title,
  submitText = "Assinar",
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <div className="modal-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 9V14M12 17.01L12.01 16.998M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className="modal-title">Atenção</h2>

        <div className="modal-body text-center">
          <p style={{ textAlign: "center", marginBottom: "24px" }}>{title}</p>

          <div className="modal-actions">
            <button
              className="btn-primary big"
              style={{ width: "100%" }}
              onClick={onSubscribe}
            >
              {submitText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlert;
